import React from 'react';
import './UKUniversities.css';

const universities = {
  F: [
    "Far Eastern Federal University (FEFU)",
  ],
  H: [
    "HSE University (Higher School of Economics)",
  ],
  K: [
    "Kazan Federal University",
    "Kuban State University",
  ],
  L: [
    "Lobachevsky University (Nizhny Novgorod State University)",
  ],
  M: [
    "Moscow Institute of Physics and Technology (MIPT)",
    "Moscow State Institute of International Relations (MGIMO)",
    "Moscow State Technical University of Civil Aviation",
    "Moscow State University (Lomonosov MSU)",
    "Moscow Power Engineering Institute (MPEI)",
    "Moscow Aviation Institute (MAI)",
  ],
  N: [
    "National Research Nuclear University MEPhI",
    "National University of Science and Technology MISIS",
    "Novosibirsk State University (NSU)",
  ],
  P: [
    "Peter the Great St. Petersburg Polytechnic University",
    "Plekhanov Russian University of Economics",
  ],
  S: [
    "Saint Petersburg Electrotechnical University (LETI)",
    "Saint Petersburg State University (SPbU)",
    "Southern Federal University",
    "Siberian Federal University",
  ],
  T: [
    "Tomsk State University",
    "Tomsk Polytechnic University",
    "Tyumen State University",
  ],
  U: [
    "Ural Federal University (UrFU)",
  ],
  V: [
    "Voronezh State University",
  ]
};

const RussiaUniversities = () => {
  return (
    <div className="uk-container">
      <h2 className="uk-title">Russia Universities</h2>
      <table className="uk-table">
        <thead>
          <tr>
            <th>Letter</th>
            <th>University Name</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(universities).map(([letter, uniList]) =>
            uniList.map((uni, idx) => (
              <tr key={`${letter}-${idx}`}>
                <td>{idx === 0 ? letter : ''}</td>
                <td>{uni}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default RussiaUniversities;
